export const API_ENDPOINTS = {
  //ADMIN

  ADMIN_LOGIN: "/admin/login",
  USER_DELETE: "/admin/delete",
  ADMIN_DETAIL: "/admin/profile",
  ADMIN_SAVE: "/admin/save-profile",
  VALIDATE_TOKEN: "/admin/validate-token",
  ADMIN_UPDATE_PASSWORD: "/admin/update-password",
  SUBSCRIBE_LIST: "/subscribe/list",
  // FILE
  FILE_LIST: "/file/list",
  FILE_SAVE: "/file/save",
  FILE_DELETE: "/file/remove",
  FILE_UPLOAD: "/file/upload",
  FILE_DOWNLOAD: "/file/download",
  FILE_PREVIEW: "/file/preview",
  FILE_REMOVE: "/file/remove",

  //ALL PAGES
  PAGE_SAVE: "/pages/save",
  PAGE_DETAIL: "/pages/details",

  //HOMEPAGE
  HOMEPAGE_DETAIL: "/homepage/details",
  HOMEPAGE_SAVE: "/homepage/save",

  //CONTACT
  CONTACT_LIST: "/contact/list",

  SETTING_LIST: "/restaurant-setting/list",
  SETTING_SAVE: "/restaurant-setting/save",
  SETTING_DELETE: "/restaurant-setting/delete",

  USER_LIST: "/admin/list",
  USER_SAVE: "/admin/update-profile",
  USER_UPDATE_PASSWORD: "/admin/update-password",
  USER_UPDATE_RESTAURANT_PROFILE: "/admin/update-restaurant-profile",

  // Blogs
  BLOG_LIST: "/blog/list",
  BLOG_SAVE: "/blog/save",
  BLOG_DELETE: "/blog/delete",
  BLOG_DETAILS: "/blog/details",

  // Author
  AUTHOR_LIST: "/author/list",
  AUTHOR_SAVE: "/author/save",
  AUTHOR_DELETE: "/author/delete",
  AUTHOR_DETAILS: "/author/details",

  // Setting Endpoints
  APPLICATION_SETTING_CREATE: "/setting/save",
  APPLICATION_SETTING_DETAILS: "/setting/details",
  APPLICATION_SETTING_UPDATE: "/setting/update",

  // My Company Endpoints
  MY_COMPANY: "/my-company",

  // Industry Endpoints
  INDUSTRY_LIST: "/industries",
  INDUSTRY_DETAIL: "/industries",

  // Job Endpoints
  JOB_LIST: "/jobs/list",
  JOB_DETAILS: "/jobs/detail",
  JOB_CREATE: "/jobs/create",
  JOB_UPDATE: "/jobs/update",
  JOB_DELETE: "/jobs/delete",
  JOB_SAVE: "/jobs/create",
  JOB_PHOTOS: "/jobs/:id/photos",
  JOB_TIME_LOGS: "/jobs/:id/time-logs",
  JOB_CLOCK_IN: "/jobs/:id/time-logs/clock-in",
  JOB_CLOCK_OUT: "/jobs/:id/time-logs/:logId/clock-out",
  JOB_TIME_LOG_UPDATE: "/jobs/:id/time-logs/:logId",
  JOB_CHECKLIST_RESPONSES: "/jobs/:id/checklist-responses",
  JOB_PARTS: "/jobs/:id/parts",
  JOB_SIGN_OFF: "/jobs/:id/sign-off",
  JOB_NOTES: "/jobs/:id/notes",
  JOB_NOTE_DELETE: "/jobs/:id/notes/:nid",

  // Incident / RIDDOR
  INCIDENT_LIST: "/incidents/list",
  INCIDENT_DETAIL: "/incidents/detail",
  INCIDENT_UPDATE_STATUS: "/incidents/update-status",

  // Vehicle daily checks
  VEHICLE_DAILY_CHECKS_LIST: "/vehicles/daily-checks/list",

  // COSHH
  COSHH_LIST: "/coshh/list",
  COSHH_DETAIL: "/coshh/detail",
  COSHH_CREATE: "/coshh/create",
  COSHH_UPDATE: "/coshh/update",
  COSHH_DELETE: "/coshh/delete",

  // Timesheets
  TIMESHEET_LIST: "/timesheets/list",
  TIMESHEET_STATS: "/timesheets/stats",
  TIMESHEET_DETAIL: "/timesheets/detail",
  TIMESHEET_APPROVE: "/timesheets/approve",
  TIMESHEET_REJECT: "/timesheets/reject",

  // Payslips
  PAYSLIP_LIST: "/payslips/list",
  PAYSLIP_CREATE: "/payslips/create",
  PAYSLIP_DELETE: "/payslips/delete",

  // Messages
  MESSAGE_THREAD_LIST: "/messages/threads/list",
  MESSAGE_THREAD_CREATE: "/messages/threads/create",
  MESSAGE_THREAD_MESSAGES: "/messages/threads/:id/messages",
  MESSAGE_SEND: "/messages/send",
  MESSAGE_THREAD_RESOLVE: "/messages/threads/resolve",

  // Lone Worker
  LONE_WORKER_SESSIONS: "/lone-worker/sessions/list",
  LONE_WORKER_SOS_LIST: "/lone-worker/sos/list",
  LONE_WORKER_SOS_RESOLVE: "/lone-worker/sos/resolve",

  // Worker Quote Requests
  WORKER_QUOTE_REQUEST_LIST: "/worker-quote-requests/list",
  WORKER_QUOTE_REQUEST_REVIEW: "/worker-quote-requests/review",

  // Notifications
  NOTIFICATION_LIST: "/notifications/list",
  NOTIFICATION_RECIPIENTS: "/notifications/recipients",
  NOTIFICATION_DISPATCH: "/notifications/dispatch",
  WORKER_STATS: "/notifications/worker-stats",

  // Buildings Endpoints
  BUILDINGS_LIST: "/buildings/list",
  BUILDINGS_SAVE: "/buildings/save",
  BUILDINGS_DELETE: "/buildings/delete",
  BUILDINGS_DETAILS: "/buildings/details",

  // Site Manager Endpoints
  Site_Manager_LIST: "/site-manager/list",
  Site_Manager_SAVE: "/site-manager/save",
  Site_Manager_DELETE: "/site-manager/delete",
  Site_Manager_DETAILS: "/site-manager/details",

  // Registered User List EndPoints
  REGISTERED_USER_LIST: "/user/list",
  CREATE_USER: "/user/save",
  REGISTERED_USER_DETAILS: "/user/details",
  REGISTERED_USER_DELETE: "/user/delete",

  // Recipients Endpoints
  RECIPIENTS_LIST: "/recipients/list",
  RECIPIENTS_SAVE: "/recipients/save",
  RECIPIENTS_DELETE: "/recipients/delete",
  RECIPIENTS_DETAILS: "/recipients/details",

  // Reports list
  REPORTS_LIST: "/reports/list",
  REPORTS_UPLOAD: "/reports/upload",
  REPORTS_CREATE: "/reports/create",
  REPORTS_DOWNLOAD: "/reports/download",

  //FORM-FIELDS
  FORM_CREATE: "/form-fields/save",
  FORM_LIST: "/form-fields/list",
  FORM_DETAILS: "/form-fields/details",
  FORM_DELETE: "/form-fields/delete",

  //FORM-SECTIONS
  FORM_SECTION_CREATE: "/form-sections/save",
  FORM_SECTION_LIST: "/form-sections/list",
  FORM_SECTION_DETAILS: "/form-sections/details",
  FORM_SECTION_DELETE: "/form-sections/delete",

  // Sub Admin Endpoints
  SUB_ADMIN_LIST: "/sub-admin/list",
  SUB_ADMIN_SAVE: "/sub-admin/save",
  SUB_ADMIN_DELETE: "/sub-admin/delete",
  SUB_ADMIN_DETAILS: "/sub-admin/details",

  // Audit Logs Endpoints
  AUDIT_LOGS_LIST: "/admin-logs/list",

  // Dashboard Endpoints
  DASHBOARD_STATS: "/dashboard/details",

  // Analytics / Reports
  REPORTS_JOBS_PER_PERIOD: "/reports/jobs-per-period",
  REPORTS_REVENUE_PER_PERIOD: "/reports/revenue-per-period",
  REPORTS_TECH_UTILISATION: "/reports/technician-utilisation",

  // Service Endpoints
  SERVICE_LIST: "/service/list",
  SERVICE_SAVE: "/service/save",
  SERVICE_DELETE: "/service/delete",
  SERVICE_DETAILS: "/service/details",

  // Team Endpoints
  TEAM_LIST: "/team/list",
  TEAM_SAVE: "/team/save",
  TEAM_DELETE: "/team/delete",
  TEAM_DETAILS: "/team/details",

  // Issues Endpoints
  ISSUES_LIST: "/issues/list",
  ISSUES_SAVE: "/issues/save",

  // Project Endpoints
  PROJECT_LIST: "/projects/list",
  PROJECT_DELETE: "/projects/delete",
  PROJECT_RESTORE: "/projects/restore",

  // Client Endpoints
  CLIENT_LIST: "/clients/list",
  CLIENT_DETAIL: "/clients/detail",
  CLIENT_CREATE: "/clients/create",
  CLIENT_UPDATE: "/clients/update",
  CLIENT_DELETE: "/clients/delete",
  CLIENT_SITES: "/clients",

  // Invoice Credit Note
  INVOICE_CREDIT_NOTE: "/invoices/credit-note",

  // Quote Endpoints
  QUOTE_LIST: "/quotes/list",
  QUOTE_DETAIL: "/quotes/detail",
  QUOTE_CREATE: "/quotes/create",
  QUOTE_UPDATE: "/quotes/update",
  QUOTE_DELETE: "/quotes/delete",
  QUOTE_SEND: "/quotes/send",
  QUOTE_STATS: "/quotes/stats",
  QUOTE_CONVERT_TO_JOB: "/quotes/convert-to-job",
  QUOTE_ACCEPT_ON_BEHALF: "/quotes/:id/accept-on-behalf",

  // Location Endpoints
  LOCATION_COUNTRIES: "/location/countries",
  LOCATION_STATES: "/location/states",
  LOCATION_CITIES: "/location/cities",

  // Purchase Order Endpoints
  PO_LIST: "/purchase-orders/list",
  PO_DETAIL: "/purchase-orders/detail",
  PO_CREATE: "/purchase-orders/create",
  PO_UPDATE: "/purchase-orders/update",
  PO_DELETE: "/purchase-orders/delete",
  PO_STATS: "/purchase-orders/stats",
  PO_STATUS: "/purchase-orders/status",
  PO_CANCEL: "/purchase-orders/cancel",
  PO_SHARE: "/purchase-orders",
  PUBLIC_PO: "/public/purchase-orders",

  // Invoice Endpoints
  INVOICE_LIST: "/invoices/list",
  INVOICE_DETAIL: "/invoices/detail",
  INVOICE_CREATE: "/invoices/create",
  INVOICE_UPDATE: "/invoices/update",
  INVOICE_DELETE: "/invoices/delete",
  INVOICE_STATS: "/invoices/stats",
  INVOICE_STATUS: "/invoices/status",
  INVOICE_PAYMENT: "/invoices/payment",
  INVOICE_FROM_QUOTE: "/invoices/from-quote",
  INVOICE_FROM_PO: "/invoices/from-po",
  INVOICE_PDF: "/invoices/pdf",
  INVOICE_SHARE: "/invoices",
  PUBLIC_INVOICE: "/public/invoices",

  // Company Config — Branches
  BRANCH_LIST: "/company-config/branches/list",
  BRANCH_DETAIL: "/company-config/branches/detail",
  BRANCH_CREATE: "/company-config/branches/create",
  BRANCH_UPDATE: "/company-config/branches/update",
  BRANCH_DELETE: "/company-config/branches/delete",

  // Company Config — Divisions
  DIVISION_LIST: "/company-config/divisions/list",
  DIVISION_DETAIL: "/company-config/divisions/detail",
  DIVISION_CREATE: "/company-config/divisions/create",
  DIVISION_UPDATE: "/company-config/divisions/update",
  DIVISION_DELETE: "/company-config/divisions/delete",

  // Company Config — Holidays
  HOLIDAY_LIST: "/company-config/holidays/list",
  HOLIDAY_UPCOMING: "/company-config/holidays/upcoming",
  HOLIDAY_DETAIL: "/company-config/holidays/detail",
  HOLIDAY_CREATE: "/company-config/holidays/create",
  HOLIDAY_UPDATE: "/company-config/holidays/update",
  HOLIDAY_DELETE: "/company-config/holidays/delete",

  // Company Config — Feature Overrides
  FEATURE_OVERRIDE_LIST: "/company-config/feature-overrides/list",
  FEATURE_OVERRIDE_KEY: "/company-config/feature-overrides/key",
  FEATURE_OVERRIDE_SET: "/company-config/feature-overrides/set",
  FEATURE_OVERRIDE_REMOVE: "/company-config/feature-overrides/remove",

  // Status History
  STATUS_HISTORY_LIST: "/status-history/list",

  // Master: Certifications & Compliances (read-only for company admin)
  MASTER_CERTIFICATIONS: "/master/certifications",
  MASTER_COMPLIANCES: "/master/compliances",

  // Field Workers
  FIELD_WORKER_LIST: "/field-workers/list",
  FIELD_WORKER_LOCATIONS: "/field-workers/locations",
  FIELD_WORKER_DETAIL: "/field-workers/detail",
  FIELD_WORKER_CREATE: "/field-workers/create",
  FIELD_WORKER_UPDATE: "/field-workers/update",
  FIELD_WORKER_DELETE: "/field-workers/delete",

  // Staff Management
  STAFF_LIST: "/staff/list",
  STAFF_DETAIL: "/staff/detail",
  STAFF_CREATE: "/staff/create",
  STAFF_UPDATE: "/staff/update",
  STAFF_DELETE: "/staff/delete",

  // Ledger
  LEDGER_LIST: "/ledger/list",
  LEDGER_CREATE: "/ledger/create",
  LEDGER_UPDATE: "/ledger/update",
  LEDGER_DELETE: "/ledger/delete",

  // Tenders
  TENDER_LIST: "/tenders/list",
  TENDER_CREATE: "/tenders/create",
  TENDER_UPDATE: "/tenders/update",
  TENDER_DELETE: "/tenders/delete",

  GLOBAL_SEARCH: "/global-search/list",

  // Suppliers
  SUPPLIER_LIST: "/suppliers/list",
  SUPPLIER_DETAIL: "/suppliers/detail",
  SUPPLIER_CREATE: "/suppliers/create",
  SUPPLIER_UPDATE: "/suppliers/update",
  SUPPLIER_DELETE: "/suppliers/delete",

  // Vehicles
  VEHICLE_LIST: "/vehicles/list",
  VEHICLE_DETAIL: "/vehicles/detail",
  VEHICLE_CREATE: "/vehicles/create",
  VEHICLE_UPDATE: "/vehicles/update",
  VEHICLE_DELETE: "/vehicles/delete",
  VEHICLE_DEFECT_CHECKS: "/vehicles/:id/defect-checks",
  VEHICLE_DEFECT_CHECK_CREATE: "/vehicles/defect-checks/create",
  VEHICLE_DEFECTS_LIST: "/vehicles/defects/list",
  VEHICLE_DEFECT_CREATE: "/vehicles/defects/create",
  VEHICLE_DEFECT_RESOLVE: "/vehicles/defects/resolve",
  VEHICLE_MILEAGE_LIST: "/vehicles/mileage/list",
  VEHICLE_MILEAGE_CREATE: "/vehicles/mileage/create",

  // Inventory — Part Categories
  PART_CATEGORY_LIST: "/inventory/categories/list",
  PART_CATEGORY_CREATE: "/inventory/categories/create",
  PART_CATEGORY_UPDATE: "/inventory/categories/update",
  PART_CATEGORY_DELETE: "/inventory/categories/delete",

  // Inventory — Parts
  PART_LIST: "/inventory/parts/list",
  PART_DETAIL: "/inventory/parts/detail",
  PART_CREATE: "/inventory/parts/create",
  PART_UPDATE: "/inventory/parts/update",
  PART_DELETE: "/inventory/parts/delete",

  // Inventory — Stock Locations
  STOCK_LOCATION_LIST: "/inventory/locations/list",
  STOCK_LOCATION_CREATE: "/inventory/locations/create",
  STOCK_LOCATION_UPDATE: "/inventory/locations/update",
  STOCK_LOCATION_DELETE: "/inventory/locations/delete",

  // Inventory — Stock Levels
  STOCK_LEVEL_LIST: "/inventory/levels/list",

  // Inventory — Stock Movements
  STOCK_MOVEMENT_LIST: "/inventory/movements/list",
  STOCK_MOVEMENT_CREATE: "/inventory/movements/create",

  // Job Config — Job Types
  JOB_TYPE_LIST: "/job-config/job-types/list",
  JOB_TYPE_CREATE: "/job-config/job-types/create",
  JOB_TYPE_UPDATE: "/job-config/job-types/update",
  JOB_TYPE_DELETE: "/job-config/job-types/delete",
  JOB_TYPE_CERTIFICATION_TYPES_LIST: "/job-config/certification-types/list",
  JOB_TYPE_REQUIRED_CERTIFICATIONS: "/job-config/job-types", // + /:id/required-certifications

  // Job Config — Pipelines
  PIPELINE_LIST: "/job-config/pipelines/list",
  PIPELINE_CREATE: "/job-config/pipelines/create",
  PIPELINE_UPDATE: "/job-config/pipelines/update",
  PIPELINE_DELETE: "/job-config/pipelines/delete",

  // Job Config — Stages
  STAGE_CREATE: "/job-config/stages/create",
  STAGE_UPDATE: "/job-config/stages/update",
  STAGE_DELETE: "/job-config/stages/delete",

  // Job Config — Checklists
  CHECKLIST_LIST: "/job-config/checklists/list",
  CHECKLIST_DETAIL: "/job-config/checklists/detail",
  CHECKLIST_CREATE: "/job-config/checklists/create",
  CHECKLIST_UPDATE: "/job-config/checklists/update",
  CHECKLIST_DELETE: "/job-config/checklists/delete",
  CHECKLIST_SAVE_ITEMS: "/job-config/checklists/save-items",

  // Job Config — Form Templates
  FORM_TEMPLATE_LIST: "/job-config/form-templates/list",
  FORM_TEMPLATE_DETAIL: "/job-config/form-templates/detail",
  FORM_TEMPLATE_CREATE: "/job-config/form-templates/create",
  FORM_TEMPLATE_UPDATE: "/job-config/form-templates/update",
  FORM_TEMPLATE_DELETE: "/job-config/form-templates/delete",
  FORM_TEMPLATE_SECTION_CREATE: "/job-config/form-templates/sections/create",
  FORM_TEMPLATE_FIELD_CREATE: "/job-config/form-templates/fields/create",

  // Contracts
  CONTRACT_LIST: "/contracts/list",
  CONTRACT_DETAIL: "/contracts/detail",
  CONTRACT_CREATE: "/contracts/create",
  CONTRACT_UPDATE: "/contracts/update",
  CONTRACT_DELETE: "/contracts/delete",

  // Leave Management
  LEAVE_LIST: "/leave-management/list",
  LEAVE_APPROVE: "/leave-management/approve",
  LEAVE_REJECT: "/leave-management/reject",
  LEAVE_ENTITLEMENT_LIST: "/leave-management/holiday-entitlements",
  LEAVE_ENTITLEMENT_UPSERT: "/leave-management/holiday-entitlements",

  // DBS Checks
  DBS_LIST: "/dbs-checks/list",
  DBS_CREATE: "/dbs-checks/create",
  DBS_UPDATE: "/dbs-checks/update",
  DBS_DELETE: "/dbs-checks/delete",

  // Right to Work
  RTW_LIST: "/right-to-work/list",
  RTW_CREATE: "/right-to-work/create",
  RTW_UPDATE: "/right-to-work/update",
  RTW_DELETE: "/right-to-work/delete",

  // AI Agent
  AI_AGENT_CHAT: "/ai-agent/chat",

  // Asset Management
  ASSET_TYPE_LIST: "/assets/asset-types/list",
  ASSET_TYPE_CREATE: "/assets/asset-types/create",
  ASSET_TYPE_UPDATE: "/assets/asset-types",
  ASSET_TYPE_DELETE: "/assets/asset-types",
  ASSET_LIST: "/assets/list",
  ASSET_DETAIL: "/assets/detail",
  ASSET_CREATE: "/assets/create",
  ASSET_UPDATE: "/assets/update",
  ASSET_DELETE: "/assets/delete",
  ASSET_SERVICE_HISTORY: "/assets",
  ASSET_EXPIRING: "/assets/expiring",

  // Industry Seed
  INDUSTRY_SEED: "/industry/seed",
  INDUSTRY_SEED_SLUGS: "/industry/slugs",

  // Employee Locations (latest — used on map view)
  EMPLOYEE_LOCATIONS_LATEST: "/employee-locations/latest",

  // CIS — Construction Industry Scheme
  CIS_LIST: "/cis/list",

  // NMW — National Minimum Wage
  NMW_LIST: "/nmw/checks",
  NMW_RUN_CHECK: "/nmw/checks",
  NMW_BULK_CHECK: "/nmw/checks/bulk",

  // Pension Auto-Enrolment
  PENSION_LIST: "/pension/enrolments",
  PENSION_SETTINGS: "/pension/settings",
  PENSION_ENROL: "/pension/enrolments",
  PENSION_OPT_OUT: (id: number) => `/pension/enrolments/${id}/opt-out`,

  // Integrations
  INTEGRATION_LIST: "/integrations",
  INTEGRATION_CONNECT_URL: (provider: string) => `/integrations/connect/${provider}`,
  INTEGRATION_DISCONNECT: (id: number) => `/integrations/${id}/disconnect`,
  INTEGRATION_STATUS: "/integrations/status",

  // Billing
  BILLING_INVOICES: "/billing/invoices",
  BILLING_INVOICE_PDF: (id: number) => `/billing/invoices/${id}/pdf`,

  // Notification Preferences
  NOTIFICATION_PREFERENCES: "/notification-preferences/preferences",

  // Admin Users (company dashboard team members)
  ADMIN_USER_LIST: "/admin/list",
  ADMIN_USER_INVITE: "/admin/invite",
  ADMIN_USER_UPDATE: "/admin/update",
  ADMIN_USER_DELETE: "/admin",

  // Quote Templates
  QUOTE_TEMPLATE_LIST: "/quote-templates",
  QUOTE_TEMPLATE_CREATE: "/quote-templates/create",
  QUOTE_TEMPLATE_DELETE: (id: number) => `/quote-templates/delete/${id}`,
};

export const subAdminModule = [
  "DASHBOARD",
  "SUBADMIN",
  //  "FILES",
  "REPORTS",
  "USERS_ACCESS",
  "WEBSITE",
  "SETTINGS",
  "CONTACTS",
  "ISSUES",
  "SUBSCRIBE",
  "PROJECTS",
  //  "BUILDINGS",
  //  "JOBS",
  //  "CREATE_REPORT_FORM",
  //  "RECIPIENTS",
  //  "AUDIT_LOGS",
  //  "SITE_MANAGER",
];
